<template>
  <div class="content-wrapper bg-white shadow-sm">
    <RouterLink to="/" class="btn btn-outline-secondary mb-4"><i class="fa-solid fa-arrow-left"></i> <i class="fa-solid fa-house"></i></RouterLink>

    <h1 class="mb-4">What is my nutrient load?</h1>
    <p>
To comply with SBTN’s freshwater quality target, companies need to know the nutrient loading they are responsible for. In contrast to domestic and industrial emissions, which typically enter water systems from point sources, agricultural emissions originate from diffuse sources. This situation makes it difficult to estimate the amounts of N and P that run off, erode from, or leach out of agricultural fields into water bodies. Moreover, how much N and P finds its way to water systems depends on many factors, including the type of crop grown, soil type, and farming practices. Therefore, modeling studies often approximate agricultural nutrient loading. This Nutrient Navigator, developed by SBTN and the Water Footprint Network, leverages insights and data from scientific studies to offer users an open and freely accessible global database of approximate N and P loading by crop group and sub-catchment (in kg/ha/yr). For specific guidance on how to use approximated load intensitities from the Nutrient Navigator in the target setting process, see <a href="https://sciencebasedtargetsnetwork.org/companies/take-action/set-targets/freshwater-targets/" target="_BLANK">SBTN’s Technical Guidance</a>.
    </p>
  </div>

  <section class="py-5 text-center bg-primary mt-5">
    <div class="container">
      <RouterLink to="/map" class="map-btn">
        <div class="goto">
        view the map<br/><i class="fa-solid fa-caret-right"></i><i class="fa-solid fa-caret-right"></i>
        </div>
      </RouterLink>
    </div>
  </section>

  <div class="bottom-hide"></div>
  <div class="bottom-row bg-white">
    <span class="nut">Nutrient Navigator</span>
    <span class="opt">a product from</span>
    <a href="https://sciencebasedtargetsnetwork.org/"><img src="../assets/img/sbtn-logo-yellow.svg"/></a>
    <span class="opt">and</span>
    <a href="https://www.waterfootprint.org/"><img src="../assets/img/wfn-logo.png"/></a>
  </div>
</template>

<script>
export default {
  name: "MyLoad"
}
</script>

<style>
</style>
